export default "__VITE_ASSET__DBzIJIlP__"